/* eslint-disable */

import plansMeta from '@meta/plans'

export default {
  data() {
    return {
      plansMeta
    }
  },
}
